import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Field from '@/components/common/Field.jsx';
import EmptyState from '@/components/common/EmptyState.jsx';
import { monitorRecepcion, recepcionesBySucursal } from '@/services/recepcionCarga.js';
import {
  CargasPage,
  CargasSection,
  CargasStickyActions,
  CargasTableShell,
  CargasViewport,
  cargasButtonClassName,
  cargasInputClassName,
  cargasPrimaryButtonClassName,
} from '../components/CargasLayout.jsx';

export default function RecepcionList() {
  const navigate = useNavigate();
  const [sucursalId, setSucursalId] = useState('1');
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState({ pendientes: 0, recibidasHoy: 0, conIncidenciaHoy: 0 });

  useEffect(() => {
    recepcionesBySucursal({ sucursalId }).then(setRows).catch(() => setRows([]));
    monitorRecepcion(sucursalId)
      .then(setStats)
      .catch(() => setStats({ pendientes: 0, recibidasHoy: 0, conIncidenciaHoy: 0 }));
  }, [sucursalId]);

  return (
    <CargasPage
      title="Recepcion de cargas"
      description="Recepcion por foja o guia con control por sucursal destino."
      hideHeaderOnCompact
      footer={
        <CargasStickyActions
          summary={
            <div className="flex flex-wrap items-center gap-3 text-xs text-[rgba(var(--muted),0.92)]">
              <span>Pendientes: {stats.pendientes}</span>
              <span>Recibidas hoy: {stats.recibidasHoy}</span>
              <span>Con incidencia: {stats.conIncidenciaHoy}</span>
            </div>
          }
          actions={
            <>
              <button
                type="button"
                className={cargasButtonClassName}
                onClick={() => navigate('/cargas/recepcion/nueva?tipo=foja')}
              >
                Recepcion por foja
              </button>
              <button
                type="button"
                className={cargasButtonClassName}
                onClick={() => navigate('/cargas/recepcion/nueva?tipo=guia')}
              >
                Recepcion por guia
              </button>
              <button
                type="button"
                className={cargasPrimaryButtonClassName}
                onClick={() => navigate('/cargas/recepcion/nueva')}
              >
                Nueva recepcion
              </button>
            </>
          }
        />
      }
    >
      <CargasViewport className="grid grid-cols-12 gap-3">
        <CargasSection
          title="Recepciones recientes"
          description="Pendientes y cerradas con incidencia."
          className="col-span-12 md:col-span-8"
          bodyClassName="min-h-0 flex-1 p-4"
        >
          {rows.length === 0 ? (
            <EmptyState title="No hay recepciones" description="Crea una nueva recepcion para comenzar." />
          ) : (
            <CargasTableShell className="max-h-[300px]">
              <table className="min-w-full text-left text-sm">
                <thead className="sticky top-0 bg-[rgb(var(--panel))] text-[rgba(var(--muted),0.9)]">
                  <tr>
                    <th className="px-3 py-2">ID</th>
                    <th className="px-3 py-2">Tipo</th>
                    <th className="px-3 py-2">Estado</th>
                    <th className="px-3 py-2">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(row => (
                    <tr key={row.id} className="border-t border-[rgba(var(--border),0.45)]">
                      <td className="px-3 py-2">
                        <Link to={`/cargas/recepcion/${row.id}`} className="font-semibold text-[rgb(var(--brand))]">
                          #{row.id}
                        </Link>
                      </td>
                      <td className="px-3 py-2">{row.tipo}</td>
                      <td className="px-3 py-2">{row.estado}</td>
                      <td className="px-3 py-2">{new Date(row.fechaRecepcion).toLocaleString('es-AR')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CargasTableShell>
          )}
        </CargasSection>

        <CargasSection
          title="Sucursal y monitor"
          className="col-span-12 md:col-span-4"
          bodyClassName="space-y-3 p-4"
        >
          <Field label="Sucursal destino" htmlFor="sucursal">
            <input
              id="sucursal"
              value={sucursalId}
              onChange={e => setSucursalId(e.target.value)}
              className={cargasInputClassName}
            />
          </Field>

          <div className="grid grid-cols-1 gap-2 text-sm">
            <div className="rounded-xl border border-[rgba(var(--border),0.45)] px-3 py-2">
              Pendientes <strong className="ml-2">{stats.pendientes}</strong>
            </div>
            <div className="rounded-xl border border-[rgba(var(--border),0.45)] px-3 py-2">
              Recibidas hoy <strong className="ml-2">{stats.recibidasHoy}</strong>
            </div>
            <div className="rounded-xl border border-[rgba(var(--border),0.45)] px-3 py-2">
              Con incidencia <strong className="ml-2">{stats.conIncidenciaHoy}</strong>
            </div>
          </div>
        </CargasSection>
      </CargasViewport>
    </CargasPage>
  );
}
